import { render, staticRenderFns } from "./batchNumberDetail.vue?vue&type=template&id=55bd8ad6&scoped=true"
import script from "./batchNumberDetail.vue?vue&type=script&lang=js"
export * from "./batchNumberDetail.vue?vue&type=script&lang=js"
import style0 from "./batchNumberDetail.vue?vue&type=style&index=0&id=55bd8ad6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd8ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55bd8ad6')) {
      api.createRecord('55bd8ad6', component.options)
    } else {
      api.reload('55bd8ad6', component.options)
    }
    module.hot.accept("./batchNumberDetail.vue?vue&type=template&id=55bd8ad6&scoped=true", function () {
      api.rerender('55bd8ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/payableCollection/cmp/batchNumberDetail.vue"
export default component.exports